import { ChevronsDown, ChevronsUp } from '@gravity-ui/icons';
import { Icon, Label } from '@gravity-ui/uikit';

interface ScoreLabelProps {
	value: number | undefined;
}

export const ScoreLabel: React.FC<ScoreLabelProps> = ({ value }) => {
	if (value === undefined) {
		return <Label theme="unknown">-</Label>;
	}

	if (value === null || value === 0) {
		return <Label theme="unknown">0</Label>;
	}

	if (value > 0) {
		return (
			<Label theme="success">
				<Icon data={ChevronsUp} size={18} /> +{value}
			</Label>
		);
	}

	if (value < -3) {
		return (
			<Label theme="danger">
				<Icon data={ChevronsDown} size={18} /> -{Math.abs(value)}
			</Label>
		);
	}

	if (value < 0) {
		return (
			<Label theme="warning">
				<Icon data={ChevronsDown} size={18} /> -{Math.abs(value)}
			</Label>
		);
	}

	return null;
};
